import React, { FC, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import StepInfo from "pages/StepPages/components";
import { Menu } from "./Menu/Menu";
import { Table } from "./Table/Table";
import { AddingProcess } from "./AddingProcess/AddingProcess";
import { SavingTemplate } from "./SavingTemplate/SavingTemplate";
import { ReactComponent as FiltrationIcon } from "images/FiltrationIcon.svg";
import { ReactComponent as FiltrationTickIcon } from "images/FiltrationTickIcon.svg";
import { getSelectedOrganization } from "toolkit/organizations/organizations.thunks";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { ChangeDisplayCriticality, ChangeStatus, resetStep_2_1 } from "toolkit/steps/stepTwo/stepTwo.slice";
import { ModalWindow } from "components/ModalWindow/ModalWindow";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import styles from "./StepTwo.module.sass";
import Badge from "components-new/Badge";
import { convertDate } from "helpers";

interface IModalWindow {
	content: React.ReactElement | null;
	visibility: boolean;
}

export const StepTwo: FC = () => {
	const dispatch = useAppDispatch();
	const { organizationId } = useParams();

	const navigate = useNavigate();

	const selectedOrganization = useAppSelector((state) => state.organizations.selectedOrganization);
	const { status } = useAppSelector((state) => state.stepTwo);

	useEffect(() => {
		if (!organizationId) return;
		if (+organizationId !== selectedOrganization?.id) dispatch(getSelectedOrganization(+organizationId));
		//eslint-disable-next-line
	}, []);

	const [modalWindow, setModalWindow] = useState<IModalWindow>({
		content: null,
		visibility: false,
	});
	const [filtration, setFiltration] = useState<string>("Отобразить все");

	const closeModalWindow = () => {
		setModalWindow({ ...modalWindow, content: null, visibility: false });
	};

	const openModalWindow = (component: React.ReactElement) => {
		setModalWindow({ ...modalWindow, content: component, visibility: true });
	};

	const criticalityHandler = (e: any, criticality: boolean) => {
		setFiltration(e.target.innerText);
		dispatch(ChangeDisplayCriticality(criticality));
	};

	useEffect(() => {
		return () => {
			dispatch(resetStep_2_1());
		};
		//eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (!selectedOrganization?.processApproved) return;
		if (status !== selectedOrganization?.processApproved) dispatch(ChangeStatus(selectedOrganization.processApproved));
		//eslint-disable-next-line
	}, []);

	return (
		<main className={styles.content}>
			<section className={styles.categorization}>
				{modalWindow.visibility && <ModalWindow close={closeModalWindow}>{modalWindow.content}</ModalWindow>}
				<div className={styles.header}>
					<div className={styles["stepInfo-wrp"]}>
						<StepInfo
							stepTitle={"2.1 Актуализация реестра бизнес-процессов"}
							info="Реестр бизнес-процессов"
							companyName={selectedOrganization?.fullName}
						/>
						<div className={styles["badge-wrp"]}>
							<Badge type={status ? "success" : "error"}>
								{status ? `Утверждён ${convertDate(status)}` : "Не утверждён"}
							</Badge>
						</div>
					</div>
					<div className={styles["header-item"]}>
						<div className={styles["filtration-wrp"]}>
							<button className={styles["filtration-btn"]}>
								<FiltrationIcon />
								<span className={styles["filtration-name"]}>{filtration}</span>
								<FiltrationTickIcon />
							</button>
							<div className={styles.filtration}>
								<button onClick={(e) => criticalityHandler(e, false)} className={styles["filtration-item"]}>
									Отобразить все
								</button>
								<button onClick={(e) => criticalityHandler(e, true)} className={styles["filtration-item"]}>
									Отобразить только критические
								</button>
							</div>
						</div>
						<Button
							variant={BUTTON_VARIANTS.OUTLINED}
							className={styles.button}
							onClick={() => {
								navigate("/references/business_process_registry/select", { state: organizationId });
							}}>
							Подключить шаблон
						</Button>
						<Button
							variant={BUTTON_VARIANTS.OUTLINED}
							onClick={() => openModalWindow(<SavingTemplate close={closeModalWindow} />)}
							className={styles.button}>
							Сохранить как шаблон
						</Button>
						<Button
							onClick={() => openModalWindow(<AddingProcess close={closeModalWindow} />)}
							className={styles.button}>
							Добавить бизнес-процесс
						</Button>
						<Menu />
					</div>
				</div>
				<Table />
			</section>
		</main>
	);
};
